<template>
  <div>
    <div class="app-modal__grid two-columns expense-general-timing-grid">
      <div class="app-modal-field">
        <span>{{ text.expenseDate }}</span>
        <VueDatePicker
          v-model="form.expenseDate"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          :placeholder="text.placeholders.date"
          :disabled="disableDates"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          hide-input-icon
          :show-now-button="true"
          :now-button-label="commonText.today"
        />
      </div>

      <div class="app-modal-field">
        <span>{{ text.paymentDate }}</span>
        <VueDatePicker
          v-model="form.paymentDate"
          class="app-modal-datepicker"
          menu-class-name="app-modal-datepicker-menu"
          :placeholder="text.placeholders.date"
          :disabled="disableDates"
          :enable-time-picker="false"
          auto-apply
          locale="es-MX"
          format="dd/MM/yyyy"
          hide-input-icon
          :show-now-button="true"
          :now-button-label="commonText.today"
        />
      </div>
    </div>

    <div class="app-modal__grid two-columns expense-concept-grid">
      <label class="app-modal-field full-width">
        <span>{{ text.concept }} *</span>
        <textarea
          v-model.trim="form.concept"
          data-focus-field="concept"
          class="form-control app-modal-field__textarea"
          :class="{ 'is-invalid': hasFieldError('concept') }"
          rows="3"
          :placeholder="text.placeholders.concept"
          @blur="touchField('concept')"
        ></textarea>
        <div class="invalid-feedback d-block" v-if="hasFieldError('concept')">
          <span v-if="v$.form.concept.$errors.length">
            {{ v$.form.concept.$errors[0].$message }}
          </span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import VueDatePicker from '@vuepic/vue-datepicker';

export default {
  name: 'ExpenseGeneralScheduleBlock',
  components: {
    VueDatePicker,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    text: {
      type: Object,
      required: true,
    },
    commonText: {
      type: Object,
      required: true,
    },
    hasFieldError: {
      type: Function,
      required: true,
    },
    touchField: {
      type: Function,
      required: true,
    },
    v$: {
      type: Object,
      default: null,
    },
    disableDates: {
      type: Boolean,
      default: false,
    },
  },
  computed: {},
};
</script>

<style scoped>
.app-modal__grid.two-columns.expense-general-timing-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

@media (max-width: 1200px) {
  .app-modal__grid.two-columns.expense-general-timing-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 700px) {
  .app-modal__grid.two-columns.expense-general-timing-grid {
    grid-template-columns: 1fr;
  }
}
</style>
